export default class PictoDto {
    constructor(obj) {
        this.url = obj.url
        this.name = obj.name
    }
}